<div class="flex flex-wrap gap-2">
  @if (selectedLabels().length < 1) {
    <span class="text-smsds"> 0 {{ noSelectKey() | transloco }} </span>
  } @else {
    @for (item of selectedLabels(); track $index) {
      <span class="flex items-center gap-1 whitespace-nowrap">
        <p-tag
          severity="secondary"
          class="px-4 py-2 text-base font-semibold shadow-xs border border-surface-700"
        >
          <span [class]="item.flagClass"></span>
          <span>{{ item.label }}</span>
          @if (!isReadOnly()) {
            <button
              type="button"
              class="ml-2 flex items-center cursor-pointer text-red"
              [attr.aria-label]="'common.delete' | transloco"
              (click)="remove.emit(item.id)"
            >
              <i class="pi pi-times-circle"></i>
            </button>
          }
        </p-tag>
        @if (item.tooltipKey) {
          <app-directus-tooltip
            tooltipStyleClass="tooltip-bg-second-level"
            [tooltipKey]="item.tooltipKey"
          ></app-directus-tooltip>
        }
      </span>
    }
  }
</div>
